// React
import React from 'react';

// Components
import Wrapper from '../../detail/Wrapper/Wrapper';

// Contexts
import { DetailContext } from '../../../contexts/detail';

// Hooks
import useDetail from '../../../hooks/useDetail';

// Third party
import { useParams } from 'react-router-dom';

// Data types
import { vistaOrderCore, vistaOrderDetail } from '../../../data-types/vistaOrder';

// This component
export default function VistaOrderDetail() {
  const { itemId } = useParams();
  const isNewItem = false;
  const isViewOnly = true;

  // Data types
  const { endpoint, getDetailId } = vistaOrderCore();
  const { baseUrl, getInputs } = vistaOrderDetail();

  // Detail
  const { cultures, saveCulturesDataSource, saveCultures } = useDetail();

  // JSX
  return (
    <DetailContext.Provider
      value={{
        typeOfData: 'data-type',
        title: 'Vista Order',
        // Static
        itemId,
        isNewItem,
        isViewOnly,
        endpoint,
        baseUrl,
        getDetailId,
        getInputs,
        // Dynamic
        cultures,
        saveCulturesDataSource,
        saveCultures
      }}>
      <Wrapper />
    </DetailContext.Provider>
  );
}
